import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { NgModule } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from './../environments/environment';

import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/register.component';
import { SigninComponent } from './signin/signin.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AuthService } from "./providers/auth.service";
import { DatabaseService } from "./providers/database.service";
import { ConnectComponent } from './connect/connect.component';
import { ListComponent } from './list/list.component';
import { InfoComponent } from './info/info.component';
import { ControlComponent } from './control/control.component';
import { VideoComponent } from './video/video.component';
import { MediatorComponent, AddNewMediator } from './mediator/mediator.component';
import { ConfigComponent } from './config/config.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    FooterComponent,
    HomeComponent,
    RegisterComponent,
    SigninComponent,
    ConnectComponent,
    ListComponent,
    InfoComponent,
    ControlComponent,
    VideoComponent,
    MediatorComponent, AddNewMediator, ConfigComponent
  ],
  imports: [
    BrowserModule, FormsModule, AppRoutingModule, 
    AngularFireModule.initializeApp(environment.firebase), AngularFireAuthModule, AngularFireDatabaseModule
  ],
  providers: [AuthService, DatabaseService],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/app.module.ts